// extracted by mini-css-extract-plugin
export default {"container":"OdqgQtQ_vaiSg49wHrlF"};